import { ErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router-dom";
import * as React from "react";
import Box from "@mui/material/Box";
import { 
  Typography, 
  Avatar, 
  Chip, 
  Container,
  Fade,
  Slide 
} from "@mui/material";
import { 
  TrendingUp, 
  Assessment, 
  Business 
} from "@mui/icons-material";

import {AdminNavbar} from "../shared-components/sidebar/SideBar";

export default function AdminStickLayout(props: any): React.ReactElement {

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
      {/* Fixed Top Navbar */}
      <AdminNavbar />
    
      {/* Main Content with top padding for fixed navbar */}
      <Box sx={{ 
        pt: { xs: '80px', md: '88px' }, // Extra margin for title visibility
        px: { xs: 2, sm: 3, md: 4 },
        pb: { xs: 2, sm: 3, md: 4 },
        minHeight: '100vh',
      }}>
        <ErrorBoundary fallback={<div>Something went wrong</div>}>
          <Outlet />
        </ErrorBoundary>
      </Box>

      {/* Global Styles */}
      <Box
        component="style"
        dangerouslySetInnerHTML={{
          __html: `
            @keyframes shimmer {
              0% { background-position: -200% 0; }
              100% { background-position: 200% 0; }
            }
            @keyframes pulse {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.05); }
            }
          `
        }}
      />
    </Box>
  );
}
